/**
 * src/features/admin/ui/CountGrid.tsx
 *
 * Count cards row: users, active_trials, active_subs, granted_licenses (ADMIN-01).
 * Extracted from MetricsGrid to keep component size under 200 lines (CLAUDE.md rule 5).
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/shared/ui/card';
import type { AdminMetrics } from '@/shared/types/admin';

export function CountGrid({ metrics }: { metrics: AdminMetrics }): React.ReactElement {
  const { t, i18n } = useTranslation();

  const countCards: Array<{ key: string; label: string; value: number }> = [
    {
      key: 'users',
      label: t('admin.metric.users', 'Users'),
      value: metrics.users,
    },
    {
      key: 'active_trials',
      label: t('admin.metric.active_trials', 'Active Trials'),
      value: metrics.active_trials,
    },
    {
      key: 'active_subs',
      label: t('admin.metric.active_subs', 'Active Subscriptions'),
      value: metrics.active_subs,
    },
    {
      key: 'granted_licenses',
      label: t('admin.metric.granted_licenses', 'Licenses Granted'),
      value: metrics.granted_licenses,
    },
  ];

  return (
    <dl className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
      {countCards.map(({ key, label, value }) => (
        <Card key={key}>
          <CardContent className="p-6 flex flex-col gap-2">
            <dt className="text-caption uppercase tracking-wide text-slate-500 dark:text-slate-400 font-semibold">
              {label}
            </dt>
            <dd className="text-subhead font-bold font-mono tabular-nums text-slate-900 dark:text-slate-50">
              {value.toLocaleString(i18n.language)}
            </dd>
          </CardContent>
        </Card>
      ))}
    </dl>
  );
}
